export const REQUEST_PARAMS = {
    sort: 'orderNumber,asc',
    page: 0,
    size: 8,
}
